import { v4 as uuidv4 } from 'uuid';

import { parseUrlState } from './url';

const getUuidFromState = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const state = urlParams.get('state');

    if (state) {
        const parsedState = parseUrlState(state);
        return parsedState.user_uuid;
    }

    return state;
};

export const ensureUserUuid = () => {
    const userUuid = getUuidFromState() || window.localStorage.getItem('user_uuid') || uuidv4();
    window.localStorage.setItem('user_uuid', userUuid);
    window.localStorage.setItem('user_uuid_time', String(new Date().getTime()));
    return userUuid;
};
